<template>
  <div class="sm_star w-full">
    <TopAppBarDrawer :isDrawerOpen="isDrawerOpen" @closeDrawer="closeDrawer"></TopAppBarDrawer>
    <!-- <TopAppBar
      :leftBtnMode="leftBtnMode"
      :rightBtnMode="rightBtnMode"
      :title="title"
      :leftBtnMethod="leftBtnMethod"
      :rightBtnMethod="rightBtnMethod"
      ref="top_app_bar"
    >
    </TopAppBar>-->
    <div class="sm_header">
      <h1>Forum</h1>
      <button class="menu_btn mdc-button" @click="openDrawer()" @keypress="openDrawer()" tabindex="0">
        <span>mobile menu</span>
      </button>
      <!-- <button class="search_btn" @click="searchOpen">
        <span>search</span>
      </button> -->
      <div class="search_box">
        <input
          type="text"
          placeholder="검색어를 입력해주세요."
          class="search_form"
          onkeydown="if (event.keyCode == 13) {search();}"
          v-model="contents"
        />
        <button type="button" class="search_close mdc-button" @click="searchClose();" @keypress="searchClose();" tabindex="0">검색 닫기</button>
        <button type="button" class="search_btn mdc-button" @click="search();" @keypress="search();" tabindex="0">검색</button>
      </div>
    </div>

    <!-- content -->
    <div class="sm_wrap">
      <div class="sm_list learning">
        <div class="user_fixed">
          <!-- userbox -->
          <div class="user_box" v-if="mamberData">
            <!-- <div class="user_img">
               <img v-if="mamberData.profile" :src="mamberData.profile" alt />
               <img v-else src="images/user.png" alt />
            </div>-->
            <div
              :style="
                mamberData.profile
                  ? `background-image: url(${mamberData.profile});`
                  : ''
              "
              class="drawer-profile-logo user_img"
            ></div>
            <div class="user_txt">
              <p class="name">{{ mamberData.name?mamberData.name.fullName:'' }}</p>
              <p class="date">{{ mamberData.storeName }} | {{ mamberData.responsibilityName }}</p>
            </div>

            <div class="user_write">
               <router-link tabindex="0" to="/forum" class="write_btn me" > {{ 'Post' }}</router-link>
              <router-link tabindex="0" to="/forums/write" class="write_btn">{{ $t('1429') }}</router-link>
              <!--<a href="#" class="write_btn"></a>-->
            </div>
          </div>
          <!-- //userbox -->
        </div>

        <div class="sm_list_box">
          <SocialLearningNoData v-if="isNoData"></SocialLearningNoData>
          <!-- list-->
          <div class="list_box" v-for="(record, index) in listData" :key="index">
            <div @click="moveToDetail(record)" @keypress="moveToDetail(record)" tabindex="0">
              <div class="user_box">
                <div class="user_img">
                  <img
                    v-if="record.auditor.register.profile"
                    :src="record.auditor.register.profile"
                  />
                  <img v-else src="images/user.png" alt />
                </div>

                <!-- <div
                :style="record.auditor.register.profile ? `background-image: url(${record.auditor.register.profiles});` : ''"
                class="drawer-profile-logo user_img"
              >
                </div>-->

                <div class="user_txt">
                  <p class="name">{{ record.auditor.register.name.fullName }}</p>
                  <p class="date">
                    {{ record.auditor.register.storeName }} |
                    {{ record.auditor.register.responsibilityName }}
                  </p>
                </div>

                <div
                  class="user_date"
                >{{ $moment(record.auditor.register.time).format("L") }}</div>
              </div>
              <!-- //userbox -->

              <div class="user_con" v-if="record.contents && record.contents.body !== ''">
                <span v-html="listFilter(record.contents.body)"></span>
                <!-- {{(record.contents && record.contents.subject!=='')? record.contents.subject:''}} -->
                <!-- {{
                record.contents && record.contents.body !== ""
                ? record.contents.body
                : ""
                }} -->
              </div>

              <div class="user_tag" v-if="record.tags && record.tags.length > 0">
                <span v-for="(tag, i) in record.tags" :key="i">#{{ tag.name }}</span>
              </div>
              <!-- <pre>
              {{ record.contents.images }}
              </pre>-->
              <div class="user_imgList mgb-16" v-if="record.contents.images.length > 2">
                <a href="#">
                  <img :src="record.contents.images[0].resourceUri" alt />
                </a>
                <a href="#">
                  <img
                    v-if="record.contents.images[1]"
                    :src="record.contents.images[1].resourceUri"
                    alt
                  />
                </a>
                <a href="#" class="more">
                  <img
                    v-if="record.contents.images[2]"
                    :src="record.contents.images[2].resourceUri"
                    alt
                  />
                  <span>+2</span>
                </a>
              </div>

              <div class="user_imgList mgb-16" v-if="record.contents.images.length == 2">
                <a href="#" v-for="(img,index1) in record.contents.images" :key="index1" style="width: 48.9%;padding-top: 32%;">
                  <img :src="img.resourceUri" alt />
                </a>
              </div>
              <div class="user_imgList mgb-16" v-if="record.contents.images.length == 1">
                <a href="#" style="width: 100%;padding-top: 100%;">
                  <img :src="record.contents.images[0].resourceUri" alt />
                </a>
              </div>

            </div>
            <div class="user_opt">
              {{ $t("1430", { str: record.likesCount }) }} &nbsp;&nbsp;
              {{ $t("1431", { str: record.commentCount }) }}
              <span
                class="right"
              >{{ $t("1432", { str: record.viewCount }) }}</span>
            </div>

            <div class="list_btn">
              <!-- <a href="#" class="like">{{ $t("1433") }}</a> -->
              <a
                @click="patchLikeState(record.id, record.like);record.like = !record.like" @keypress="patchLikeState(record.id, record.like);record.like = !record.like" tabindex="0"
                class="like"
                :class="{ on: record.like }"
              >{{ $t("1433") }}</a>
              <!-- <a class="reply">{{ $t("1441") }}</a> -->
              <a
                href="javascript:void(0)"
                @click="moveToDetail(record)" @keypress="moveToDetail(record)" tabindex="0"
                class="reply"
              >{{ $t("1434") }}</a>
              <!-- <a href="#" class="share">공유하기</a> -->
            </div>
          </div>
          <!-- //list-->

          <infinite-loading @infinite="fetchData" :identifier="infiniteId" spinner="spiral">
            <div slot="no-more" class="mgt-16">No more data</div>
            <div slot="no-results" class="mgt-16"></div>
          </infinite-loading>
        </div>
      </div>
    </div>
    <!-- //content -->
  </div>
</template>
<script>
/**
 * 나의 학습 목록 메인 컴포넌트(social learning list component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import { MDCRipple } from "@material/ripple";
import socialApi from "@/api/forumApi.js";
import SocialLearningNoData from "./SocialLearningNoData.vue";
import InfiniteLoading from "vue-infinite-loading";
//import TopAppBar from "@/components/TopAppBar.vue";
import { topAppBarMixin } from "../../mixins/topAppBar.js";
import TopAppBarDrawer from "../TopAppBarDrawer.vue";

export default {
  components: {
    SocialLearningNoData,
    InfiniteLoading,
    //TopAppBar,
    TopAppBarDrawer
  },
  data: function() {
    return {
      isDrawerOpen: false,
      mamberData: [],
      contents: "",
      status: "",
      isNoData: false,
      campaignData: null,
      listData: [],
      currentPage: 1,
      totalPages: 1,
      infiniteId: +new Date()
    };
  },
  mixins: [topAppBarMixin],
  watch: {
    $route(to, from) {
      this.initData();
    }
  },
  mounted() {
    //this.setTopAppBarBackSearch(this.$t("1427"));
    this.setMaterialUi()
    socialApi
      .fetchMember()
      .then(response => {
        this.mamberData = response.data.data;
      })
      .catch(err => {
        $state.error();
      });
  },
  methods: {
    listFilter(str){
  
      let length = 300;
      let ending = ' ...';
      if (str.length > length) {
        return str.substring(0, length - ending.length) + ending;
      } else {
        return str;
      }
    },
    // method to redirect the user on Detail page if exists
    moveToDetail(record) {
      if (record && record.id) {
        this.$router.push({
          name: "SLDetail",
          params: {
            postId: record.id
          }
        });
      }
    },
    initData() {
      this.listData = [];
      this.currentPage = 1;
      this.totalPages = 1;
      this.infiniteId += 1;
    },
    fetchData($state) {
      let responseData = null;
      let params = this.setParams();

      if (this.totalPages >= this.currentPage) {
        socialApi
          .fetchList(params)
          .then(response => {
            responseData = response.data.data;
            _.map(responseData.content, o => {
              o.progressViewStatus = false;
            });

            this.listData = this.listData.concat(responseData.content);
            this.currentPage++;
            this.totalPages = responseData.totalPages;

            if (responseData.content.length) {
              $state.loaded();
            } else {
              $state.complete();
            }

            if (this.listData.length > 0) {
              this.isNoData = false;
            } else {
              this.isNoData = true;
            }
          })
          .catch(err => {
            $state.error();
          });
      } else {
        $state.complete();
      }
    },

    // 파라미터 설정(set parameter)
    setParams() {
      let params = {
        type:'MINE',
        sort: "id,desc",
        //contents: encodeURI(this.contents),
        page:this.currentPage
      };
      return params;
    },
    // Open drawer
    openDrawer() {
      this.isDrawerOpen = true;
    },
    // Close drawer
    closeDrawer() {
      this.isDrawerOpen = false;
    },
    searchOpen() {
      $(".search_box").show();
      $(".sm_star").addClass("backBg");
    },
    searchClose() {
      $(".search_box").hide();
      $(".sm_star").removeClass("backBg");
    },
    search() {
      let responseData = null;
      let params = this.setParams();
      socialApi
        .fetchList(params)
        .then(response => {
          responseData = response.data.data;
          // _.map(responseData.content, (o) => {
          //   o.progressViewStatus = false;
          // });

          this.listData = responseData.content;

          $(".search_box").hide();
          $(".sm_star").removeClass("backBg");
        })
        .catch(err => {
          $(".search_box").hide();
          $(".sm_star").removeClass("backBg");
          $state.error();
        });
    },
    patchLikeState(id, status) {
      this.$showLoading();

      let action = status
        ? socialApi.patchPostLike("SNS", id)
        : socialApi.patchPostDislike("SNS", id);

      action
        .then(response => {
          this.$hideLoading();
          //this.detail.like = !status;
        })
        .catch(err => {
          this.$error({ content: err.errMsg }).then(() => {});
        });
    }
  },
  setMaterialUi() {
            const buttonRipple = [].map.call(document.querySelectorAll('.mdc-button'), function(el) {
                let button = new MDCRipple.attachTo(el)
                return button
            })
        },
};
</script>
